<div class="home-page">
  <app-quota-header [quotaCount]="quotas.length" [activeTab]="'all'"></app-quota-header>

  <div class="container">
    <div *ngIf="loading" class="loading">
      <mat-spinner color="primary"></mat-spinner>
      <p>{{ 'homePage.loading' | translate }}</p>
    </div>

    <div *ngIf="error" class="error">
      <p>{{ 'homePage.error' | translate }} {{ error }}</p>
      <button (click)="retry()">{{ 'homePage.retry' | translate }}</button>
    </div>

    <div *ngIf="!loading && !error" class="quotas-grid">
      <app-quota-card
        *ngFor="let quota of quotas"
        [quota]="quota"
        [isAuthenticated]="isAuthenticated"
        [isSupplier]="isSupplier"
        (refreshList)="loadQuotas()">
      </app-quota-card>
    </div>

    <div *ngIf="!loading && !error && quotas.length === 0" class="empty-state">
      <p>{{ 'homePage.noQuotas' | translate }}</p>
    </div>
  </div>
</div>
